module.exports = __webpack_public_path__ + "media/images/post_alert_icon-6a70708d.png";